<template>
  <v-app v-cloak>
    <!-- <v-app v-cloak> -->

    <!-- <div class="snow"></div> -->
    <Snackbar></Snackbar>
    <v-app-bar
      absolute
      elevation="0"
      color="transparent"
      height="55"
      style="padding-bottom: 55px"
      app
    >
      <v-row>
        <v-col class="d-flex justify-start">
          <v-toolbar-title class="">
            <v-btn plain text class="py-0" to="/" :ripple="false">
              <v-icon size="50">$vuetify.icons.custom</v-icon>
              <div class="pt-2 subtitle-1 font-weight-black">UNIVERSTAT</div>
            </v-btn>
          </v-toolbar-title>
        </v-col>
        <!-- <v-spacer></v-spacer> -->
        <v-col class="d-flex justify-center">
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              plain
              class="align-self-start subtitle-1 text-capitalize"
              active-class="underline"
              color="black"
              :ripple="false"
              v-if="isLoggedIn"
              text
              to="mk"
            >
              <!-- <v-icon light>$custom</v-icon> -->
              <!-- <div class="text-sm-body-2 text-capitalize" underline>Статистика</div> -->
              Статистика
            </v-btn>
            <!-- <v-btn text to="/">
              <v-icon> mdi-home </v-icon>
            </v-btn> -->
            <!-- <v-btn text to="/about">
              <v-icon> mdi-help </v-icon>
            </v-btn> -->
            <v-btn
              plain
              class="subtitle-1 text-capitalize"
              active-class="underline"
              :ripple="false"
              text
              to="/posts"
            >
              Блог
              <!-- <v-icon> mdi-help </v-icon> -->
            </v-btn>
            <!-- <v-btn
              plain
              class="subtitle-1 text-none"
              active-class="underline"
              :ripple="false"
              text
              to="/about"
            >
              О нас
            </v-btn> -->
            <v-btn
              plain
              class="subtitle-1 text-capitalize"
              active-class="underline"
              :ripple="false"
              text
              to="/bots"
            >
              Боты
              <!-- <v-icon> mdi-help </v-icon> -->
            </v-btn>

            <!-- <v-btn v-if="isLoggedIn" text to="/logout">
              <v-icon> mdi-logout </v-icon>
            </v-btn> -->
          </v-toolbar-items>
        </v-col>
        <!-- <v-spacer></v-spacer> -->
        <v-col class="d-flex justify-end">
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn
              v-if="!isLoggedIn"
              text
              plain
              class="text-none subtitle-1"
              :ripple="false"
              active-class="underline"
              to="/login"
            >
              Вход
            </v-btn>
            <!-- <v-btn
              v-if="!isLoggedIn"
              plain
              text
              class="text-none subtitle-1"
              :ripple="false"
              active-class="underline"
              to="/register"
            >
              Регистрация
            </v-btn> -->
            <v-btn
              v-if="isLoggedIn"
              to="/me"
              plain
              color="black"
              class="text-sm-body-2 text-none"
              active-class="underline"
              :ripple="false"
              text
            >
              {{ this.getEmail() }}
            </v-btn>
            <!-- <v-btn
              v-if="isLoggedIn"
              to="/card"
              plain
              class="subtitle-1 text-none"
              active-class="underline"
              :ripple="false"
              text
            >
              Корзина
            </v-btn> -->
            <Logout v-if="isLoggedIn"> </Logout>
            <!-- <Logout></Logout> -->
          </v-toolbar-items>
        </v-col>
        <v-menu
          v-if="$vuetify.breakpoint.smOnly || $vuetify.breakpoint.xsOnly"
          v-model="dialog"
          rounded="b-xl"
          :offset-y="true"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/">
              <v-list-item-title>Домой</v-list-item-title>
            </v-list-item>
            <v-list-item to="/mk">
              <v-list-item-title>Статистика</v-list-item-title>
            </v-list-item>
            <v-list-item to="/posts">
              <v-list-item-title>Блог</v-list-item-title>
            </v-list-item>
            <v-list-item to="/about">
              <v-list-item-title>О нас</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isLoggedIn" to="/login">
              <v-list-item-title class="green--text">Вход</v-list-item-title>
            </v-list-item>
            <LogoutList
              @close-dialog="closeDialog"
              v-if="isLoggedIn"
            ></LogoutList>
          </v-list>
          <v-spacer></v-spacer>
        </v-menu>
      </v-row>
    </v-app-bar>
    <v-main>
      <!--      <div id="vk_community_messages"></div>-->
      <!--      <script type="application/javascript">-->
      <!--        VK.Widgets.CommunityMessages("vk_community_messages", 206203830, {-->
      <!--          tooltipButtonText: "Есть вопрос?",-->
      <!--          widgetPosition: "left",-->
      <!--        });-->
      <!--      </script>-->

      <router-view></router-view>
    </v-main>

    <Footer></Footer>
    <!-- <v-footer> Footer </v-footer> -->
  </v-app>
</template>

<script>
import Logout from "./Logout.vue";
import LogoutList from "./LogoutList.vue";
import Snackbar from "./Snackbar.vue";
import Footer from "./Footer.vue";
import { mapGetters } from "vuex";

export default {
  name: "app",
  components: {
    Logout,
    Snackbar,
    LogoutList,
    Footer,
  },

  data() {
    return {
      collapseOnScroll: true,
      dialog: false,
      shown: true,
    };
  },
  methods: {
    ...mapGetters(["getEmail", "getMenu"]),
    closeDialog() {
      this.dialog = false;
    },
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    isFontsReady: function () {
      // var i = 0;
      // while (i == 0) {
      //   console.log(document.fonts.check("12px Cuprum"));
      //   if (document.fonts.check("12px Cuprum")) {
      //     return true;
      //   }
      // }
      return true;
    },
  },
  // created: function () {
  //   this.$http.interceptors.response.use(undefined, function (err) {
  //     return new Promise(function (resolve, reject) {
  //       console.log(resolve);
  //       console.log(reject);
  //       if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
  //         this.$store.dispatch("logout");
  //       }
  //       throw err;
  //     });
  //   });
  // },
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}

@function random_range($min, $max) {
  $rand: random();
  $random_range: $min + floor($rand * (($max - $min) + 1));
  @return $random_range;
}

.snow {
  $total: 50;
  position: absolute;
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;

  @for $i from 1 through $total {
    $random-x: random(1000000) * 0.0001vw;
    $random-offset: random_range(-100000, 100000) * 0.0001vw;
    $random-x-end: $random-x + $random-offset;
    $random-x-end-yoyo: $random-x + ($random-offset / 2);
    $random-yoyo-time: random_range(30000, 80000) / 100000;
    $random-yoyo-y: $random-yoyo-time * 100vh;
    $random-scale: random(10000) * 0.0001;
    $fall-duration: random_range(10, 30) * 1s;
    $fall-delay: random(30) * -1s;

    &:nth-child(#{$i}) {
      opacity: random(10000) * 0.0001;
      transform: translate($random-x, -10px) scale($random-scale);
      animation: fall-#{$i} $fall-duration $fall-delay linear infinite;
    }

    @keyframes fall-#{$i} {
      #{percentage($random-yoyo-time)} {
        transform: translate($random-x-end, $random-yoyo-y) scale($random-scale);
      }

      to {
        transform: translate($random-x-end-yoyo, 100vh) scale($random-scale);
      }
    }
  }
}
#app {
  /*background-color: #e3e6ec; fallback for old browsers */
  /* background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1335%26quot%3b)' fill='none'%3e%3cpath d='M108.39 140C121.17 78.01 41.96 44.21 51.94 0C57.76 -25.79 95.97 0 140 0C210 0 210 0 280 0C350 0 350 0 420 0C490 0 490 0 560 0C630 0 630 0 700 0C754.09 0 757.8 -9.94 808.18 0C827.8 3.87 820.13 24.13 840 27.63C906.04 39.26 913.27 40.2 980 30.27C1006.13 26.38 999.97 5.56 1025.71 0C1069.97 -9.57 1072.86 0 1120 0C1179.23 0 1180.71 -5.33 1238.46 0C1250.71 1.13 1248.84 12.92 1260 12.92C1274.09 12.92 1273.42 1.44 1288.97 0C1343.42 -5.02 1344.49 0 1400 0C1437.44 0 1447.89 -19.28 1474.88 0C1517.89 30.72 1515.61 47.57 1540 100C1548.17 117.57 1540 120 1540 140C1540 210 1540 210 1540 280C1540 350 1540 350 1540 420C1540 466.66 1564.12 482.63 1540 513.33C1509.12 552.63 1485.95 541.35 1430 560C1415.95 564.68 1415 560 1400 560C1330 560 1330 560 1260 560C1190 560 1190 560 1120 560C1050 560 1050 560 980 560C910 560 910 560 840 560C770 560 770 560 700 560C630 560 630 560 560 560C490 560 490 560 420 560C350 560 350 560 280 560C210 560 210 560 140 560C122 560 118.7 569.1 104 560C48.7 525.77 37.3 523.55 0 473.33C-14.7 453.55 0 446.66 0 420C0 350 0 350 0 280C0 266 -8.25 262.66 0 252C45.94 192.66 95.2 204.01 108.39 140' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M280 101.23C235.19 101.23 179.2 120.21 179.2 140C179.2 159.92 235.54 180.65 280 180.65C300.42 180.65 308.97 160.16 308.97 140C308.97 120.45 300.08 101.23 280 101.23' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M420 270.54C411.77 272.72 405.71 274.44 405.71 280C405.71 286.78 413.78 286.85 420 295.22C465.77 356.85 460.3 361.95 509.69 420C530.3 444.22 531.59 459.75 560 459.75C612.26 459.75 655.81 460.1 671.03 420C689.92 370.22 664.18 338.61 628.21 280C608.67 248.15 597.13 240.77 560 239.08C493.02 236.04 488.91 252.26 420 270.54' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M280 408.33C274.68 408.33 270 414.44 270 420C270 424.94 274.75 429.33 280 429.33C285.97 429.33 292.44 425.01 292.44 420C292.44 414.51 285.9 408.33 280 408.33' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M140 61.25C111.79 53.46 108.39 21 108.39 0C108.39 -9.63 124.19 0 140 0C210 0 210 0 280 0C350 0 350 0 420 0C490 0 490 0 560 0C630 0 630 0 700 0C727.58 0 732.11 -12.13 755.15 0C802.11 24.71 789.95 56.41 840 73.68C902.38 95.2 915.82 95.96 980 77.57C1044.39 59.12 1036.94 33.36 1097.14 0C1106.94 -5.43 1108.57 0 1120 0C1134.36 0 1136.04 -6.05 1148.72 0C1206.04 27.34 1206.04 30.87 1260 66.77C1311.26 100.87 1334.95 90.09 1359.17 140C1386.69 196.71 1351.58 211.99 1363.48 280C1371.99 328.66 1386.13 373.33 1400 373.33C1413.14 373.33 1391.21 316.23 1417.5 280C1461.21 219.74 1502.45 180.34 1540 180.34C1563.7 180.34 1540 230.17 1540 280C1540 345.34 1562.72 365.23 1540 410.67C1527.72 435.23 1504.66 413.53 1470 420C1434.66 426.6 1422.01 412.54 1400 436.8C1358.49 482.54 1386.41 521.76 1342.96 560C1316.41 583.36 1301.48 560 1260 560C1215.2 560 1209.87 573.41 1170.4 560C1139.87 549.63 1151.51 519.9 1120 512.45C1056.31 497.4 1042.98 536.33 980 515C906.48 490.1 895.94 477.68 847 420C825.94 395.18 850.95 382.62 840 350C827.45 312.62 829.06 305.71 800 280C759.06 243.78 752.53 246.89 700 226.15C632.53 199.51 630.19 185.96 560 185.23C490.19 184.5 480.12 236.14 420 223.24C374.72 213.52 383.21 182.73 349.2 140C313.21 94.8 327.18 65.14 280 47.38C222.58 25.77 197.59 77.15 140 61.25' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M45.08 280C70.86 221.93 84.26 193.63 140 183.45C201.72 172.18 213.53 204.07 280 237.1C310.68 252.34 334.29 256.82 334.29 280C334.29 305.98 306.03 306.68 280 335.42C242.63 376.68 207.5 379.73 207.5 420C207.5 455.85 241.93 487.67 280 487.67C323.29 487.67 326.94 455.97 370.22 420C396.94 397.79 397.22 371.3 420 371.3C439.61 371.3 433.34 399.63 455 420C503.34 465.46 500.43 487.56 560 502.96C622.93 519.23 638.07 467.46 700 483.33C749.35 495.98 782.56 537.88 782.56 560C782.56 576.21 741.28 560 700 560C630 560 630 560 560 560C490 560 490 560 420 560C350 560 350 560 280 560C233.83 560 227.33 574.76 187.66 560C157.33 548.71 165.97 531.72 140 507.91C89.64 461.72 58.44 476.27 35 420C10.98 362.32 18.36 340.2 45.08 280' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M389.43 140C350.28 72.35 308.91 42.47 318.18 0C324.19 -27.53 369.09 0 420 0C490 0 490 0 560 0C630 0 630 0 700 0C701.06 0 702.12 -0.81 702.12 0C702.12 3.08 703.64 6.24 700 7.78C632.58 36.24 612.69 17.61 560 60C530.51 83.72 564.24 116.32 535.65 140C494.24 174.29 472.61 175.95 420 175.95C399.5 175.95 401.19 160.32 389.43 140' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M785 140C785 125.21 811.24 121.97 840 119.74C908.74 114.4 910.94 131.82 980 124.86C1050.94 117.72 1049.77 92.6 1120 91.54C1189.77 90.48 1192.32 100.89 1260 120.62C1275.44 125.12 1286.25 126.29 1286.25 140C1286.25 173.04 1280.05 181.17 1260 214.12C1237.45 251.17 1201.05 248.96 1201.05 280C1201.05 307.35 1235.78 301 1260 330.91C1292.47 371 1310.64 371.98 1314.44 420C1319.71 486.52 1302.33 497.81 1278.15 560C1275.11 567.81 1269.07 560 1260 560C1250.2 560 1247.81 566.01 1240.4 560C1177.81 509.22 1190.51 475.53 1120 446.42C1060.31 421.78 1046.3 461.94 980 452.5C953.55 448.73 939.15 444.54 934.5 420C922.81 358.29 970.74 338.15 947.33 280C923.49 220.79 894.19 232.03 840 185.29C813.03 162.03 785 157.98 785 140' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M104.41 280C105.43 256.88 118.09 243.79 140 243.79C185.89 243.79 239.04 245.99 240 280C241.54 334.1 192.69 350.13 145 420C142.69 423.39 142.86 426.51 140 426.51C136.47 426.51 133.4 424.86 132.22 420C115.61 351.61 101.54 344.99 104.41 280' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M1490.42 280C1490.42 258.16 1524.8 239.66 1540 239.66C1549.59 239.66 1540 259.83 1540 280C1540 306.44 1550.46 332.89 1540 332.89C1525.67 332.89 1490.42 304.77 1490.42 280' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M262.13 560C262.13 556.08 270.36 546 280 546C293.29 546 308 556.3 308 560C308 563.3 294 560 280 560C271.07 560 262.13 563.08 262.13 560' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3cpath d='M525 560C525 556.42 541.62 546.17 560 546.17C615.12 546.17 672 556.53 672 560C672 563.44 616 560 560 560C542.5 560 525 563.33 525 560' stroke='rgba(51%2c 121%2c 194%2c 0.58)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1335'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e"); */
  /* background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1075%26quot%3b)' fill='none'%3e%3cpath d='M 0%2c247 C 288%2c289.6 1152%2c417.4 1440%2c460L1440 560L0 560z' fill='rgba(163%2c 190%2c 219%2c 1)'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1075'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e"); */
  /* background-color: #ffffff; */
  background: url("../assets/wave.svg") no-repeat top center;
  /* background-attachment: fixed; */
  /* background-image: url("https://dwinawan.com/blog/bgcircle.svg"); */
  /* background: #f0f2f0; fallback for old browsers */
  /* background-color: #ee5522; */
  /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23FB3'/%3E%3Cstop offset='1' stop-color='%23ee5522'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23f7882b'/%3E%3Cstop offset='1' stop-color='%23ee5522'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg %3E%3Cg transform=''%3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg transform='rotate(-187.2 0 0)'%3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0.2' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"); */
  /* background-attachment: fixed;
  background-size: cover;  */
  /* background-color: #f2f8ff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cdefs%3E%3ClinearGradient id='a' x1='0' x2='0' y1='1' y2='0' gradientTransform='rotate(74,0.5,0.5)'%3E%3Cstop offset='0' stop-color='%232bd5ff'/%3E%3Cstop offset='1' stop-color='%23CF6'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' x1='0' x2='0' y1='0' y2='1' gradientTransform='rotate(120,0.5,0.5)'%3E%3Cstop offset='0' stop-color='%23F00'/%3E%3Cstop offset='1' stop-color='%23FC0'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg fill='%23FFF' fill-opacity='0' stroke-miterlimit='10'%3E%3Cg stroke='url(%23a)' stroke-width='3.3'%3E%3Cpath transform='translate(-30.8 -0.7999999999999998) rotate(-2.5999999999999996 1409 581) scale(0.969496)' d='M1409 581 1450.35 511 1490 581z'/%3E%3Ccircle stroke-width='1.1' transform='translate(-47 26) rotate(0.8000000000000003 800 450) scale(0.998958)' cx='500' cy='100' r='40'/%3E%3Cpath transform='translate(1 -15) rotate(1 401 736) scale(0.998958)' d='M400.86 735.5h-83.73c0-23.12 18.74-41.87 41.87-41.87S400.86 712.38 400.86 735.5z'/%3E%3C/g%3E%3Cg stroke='url(%23b)' stroke-width='1'%3E%3Cpath transform='translate(156 3.6000000000000005) rotate(-0.9000000000000001 150 345) scale(1.001832)' d='M149.8 345.2 118.4 389.8 149.8 434.4 181.2 389.8z'/%3E%3Crect stroke-width='2.2' transform='translate(-27 -72) rotate(-7.199999999999996 1089 759)' x='1039' y='709' width='100' height='100'/%3E%3Cpath transform='translate(-77.6 18.4) rotate(-1.2000000000000002 1400 132) scale(0.93)' d='M1426.8 132.4 1405.7 168.8 1363.7 168.8 1342.7 132.4 1363.7 96 1405.7 96z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed; */
  /* background-size: cover; */
  /* background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23cce8ff'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23e6f4ff'/%3E%3Cstop offset='1' stop-color='%23cce8ff'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg %3E%3Cg transform=''%3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg transform='rotate(-28.8 0 0)'%3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: cover; */
  /* background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1001%26quot%3b)' fill='none'%3e%3cpath d='M664.7370603228441 385.0898397063484L585.2252933317249 461.8734605547479 662.0089141801243 541.3852275458671 741.5206811712435 464.6016066974677z' fill='rgba(28%2c 83%2c 142%2c 0.4)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M1189.178867516007 373.4162052340896L1108.0267477955651 342.2648251065237 1076.8753676679992 423.41694482696545 1158.027487388441 454.56832495453136z' fill='rgba(28%2c 83%2c 142%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M514.9717254904069 374.6040326477865L410.45543438471407 453.362707112204 489.21410884913155 557.8789982178969 593.7303999548244 479.12032375347934z' fill='rgba(28%2c 83%2c 142%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M702.2114577042332 238.68289930555193L713.30349747373 397.3064581553017 871.9270563234797 386.21441838580495 860.835016553983 227.5908595360552z' fill='rgba(28%2c 83%2c 142%2c 0.4)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M-73.53394659071617 83.99265982865819L-8.72478116679028 148.80182525258408 56.08438425713558 19.183494404732286z' fill='rgba(28%2c 83%2c 142%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M1079.6366550873972 465.10880252434384L1116.8450892269816 614.9518955554734 1215.5517967669834 522.9064016714436z' fill='rgba(28%2c 83%2c 142%2c 0.4)' class='triangle-float3'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1001'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3cstyle%3e %40keyframes float1 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-10px%2c 0)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float1 %7b animation: float1 5s infinite%3b %7d %40keyframes float2 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-5px%2c -5px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float2 %7b animation: float2 4s infinite%3b %7d %40keyframes float3 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(0%2c -10px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float3 %7b animation: float3 6s infinite%3b %7d %3c/style%3e%3c/defs%3e%3c/svg%3e"); */
}
/* #app {
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  position: absolute;
} */
/* .bgs {
  background: url("../assets/wave.svg") no-repeat center center !important;
  /* background-color: #8f2c2c !important; */
/* top: 0 !important;
  left: 0 !important;
  height: 100vh !important;
  width: 100vw !important;
  background-size: cover !important;
  position: absolute !important;
  transform: scale(1.1) !important;
} */
.v-btn:not(.v-btn--round).v-size--default {
  padding: 0 0 !important;
}
.par {
  transform: none !important;
  width: 100% !important;
}
.underline {
  text-decoration: underline !important;
  /* text-underline-offset: 2px; */
  text-underline-position: under left;
  /* text-underline-width: 2px; */
  text-decoration-thickness: 1px;
  text-decoration-color: #000;
  /* background: #cccccc; */
}

.align-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: black;
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  transition: background-color 5000s ease-in-out 0s;
}
label.theme--dark + input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #fff !important;
  -webkit-text-size-adjust: inherit !important;
}

label.theme--light + input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #000 !important;
  -webkit-text-size-adjust: inherit !important;
}

label.theme--dark + input::-webkit-credentials-auto-fill-button {
  background-color: #fff !important;
}

input[type="password"]::-webkit-credentials-auto-fill-button {
  visibility: hidden;
  display: none !important;
  pointer-events: none;
}
/* .v-application ::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.v-application ::-webkit-scrollbar-corner {
  background: transparent;
}

.v-application ::-webkit-scrollbar-thumb {
  background: rgba(128, 134, 138, 0.3);
  border-radius: 8px;
} */
</style>
